export default __webpack_public_path__ + "static/media/blisteringwounds.1d270878.png";